import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ProfessionalHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="16601" id="treatments-overview" style={{
    marginTop: 0
  }} className="relative w-full overflow-hidden bg-primary flex items-center justify-center min-h-[40vh] md:min-h-[50vh] py-10 md:py-16">
      <div className="absolute inset-0 pointer-events-none opacity-40 bg-[#264256] z-10" aria-hidden="true" />
      <div ref={ref} className={cn("relative z-20 container mx-auto px-6 flex flex-col items-center text-center max-w-5xl transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <span className="font-default text-[12px] text-accent-foreground uppercase tracking-widest mb-8 block font-semibold">
          EU Cross-Border Healthcare Directive
        </span>
        <h1 className="font-default font-bold text-[38px] md:text-[46px] leading-[1.1] text-white tracking-normal mb-8 max-w-4xl">
          Chronic pain. <br />Treated without surgery.
        </h1>
        <p className="font-default font-medium text-base md:text-lg text-white/90 leading-relaxed max-w-2xl mb-10">
          Minimally invasive procedures performed by specialist pain doctors in Kaunas, Lithuania. Costs reimbursable through the EU Cross-Border Directive for Irish public patients.
        </p>
        <div className="flex flex-col sm:flex-row gap-5 w-full sm:w-auto">
          <Button asChild className="rounded-lg bg-[#65d19d] text-[#264256] hover:bg-[#65d19d]/90 h-12 px-10 text-sm uppercase tracking-widest hover:tracking-[0.06em] transition-all duration-300 border border-[#65d19d] shadow-md font-bold">
            <Link to="/#request-your-consultation">Book a Consultation</Link>
          </Button>
          <Button asChild className="rounded-lg bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#264256] h-12 px-10 text-sm uppercase tracking-widest hover:tracking-[0.06em] transition-all duration-300 shadow-md font-bold">
            <Link to="#our-procedures">See our procedures</Link>
          </Button>
        </div>
      </div>
    </section>;
}